<div>
  <span class="label">{{ label }}</span>
  <span class="content">
    <ng-content></ng-content>
  </span>
</div>
